import { render, staticRenderFns } from "./MarketPlaceComponent.vue?vue&type=template&id=e7131cc0&scoped=true&"
import script from "./MarketPlaceComponent.vue?vue&type=script&lang=js&"
export * from "./MarketPlaceComponent.vue?vue&type=script&lang=js&"
import style0 from "./MarketPlaceComponent.vue?vue&type=style&index=0&id=e7131cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7131cc0",
  null
  
)

export default component.exports